"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Risk API
 * Risk Service API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSupportingAcceptEncodingEnum = exports.RiskServiceApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var RiskServiceApi = /** @class */ (function (_super) {
    __extends(RiskServiceApi, _super);
    function RiskServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a designation
     * Create a designation
     */
    RiskServiceApi.prototype.createDesignationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling createDesignation.');
                        }
                        if (requestParameters.designationCreate === null || requestParameters.designationCreate === undefined) {
                            throw new runtime.RequiredError('designationCreate', 'Required parameter requestParameters.designationCreate was null or undefined when calling createDesignation.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/designations".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.DesignationCreateToJSON)(requestParameters.designationCreate),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DesignationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a designation
     * Create a designation
     */
    RiskServiceApi.prototype.createDesignation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createDesignationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create a plan
     * Create a plan
     */
    RiskServiceApi.prototype.createPlanRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling createPlan.');
                        }
                        if (requestParameters.planCreate === null || requestParameters.planCreate === undefined) {
                            throw new runtime.RequiredError('planCreate', 'Required parameter requestParameters.planCreate was null or undefined when calling createPlan.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/plans".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PlanCreateToJSON)(requestParameters.planCreate),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PlanFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create a plan
     * Create a plan
     */
    RiskServiceApi.prototype.createPlan = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createPlanRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a designation
     * Delete designation
     */
    RiskServiceApi.prototype.deleteDesignationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling deleteDesignation.');
                        }
                        if (requestParameters.designationID === null || requestParameters.designationID === undefined) {
                            throw new runtime.RequiredError('designationID', 'Required parameter requestParameters.designationID was null or undefined when calling deleteDesignation.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/designations/{designationID}".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))).replace("{".concat("designationID", "}"), encodeURIComponent(String(requestParameters.designationID))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a designation
     * Delete designation
     */
    RiskServiceApi.prototype.deleteDesignation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteDesignationRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Delete a plan
     * Delete plan
     */
    RiskServiceApi.prototype.deletePlanRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling deletePlan.');
                        }
                        if (requestParameters.planID === null || requestParameters.planID === undefined) {
                            throw new runtime.RequiredError('planID', 'Required parameter requestParameters.planID was null or undefined when calling deletePlan.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/plans/{planID}".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))).replace("{".concat("planID", "}"), encodeURIComponent(String(requestParameters.planID))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete a plan
     * Delete plan
     */
    RiskServiceApi.prototype.deletePlan = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deletePlanRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get designation
     * Get designation
     */
    RiskServiceApi.prototype.getDesignationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling getDesignation.');
                        }
                        if (requestParameters.designationID === null || requestParameters.designationID === undefined) {
                            throw new runtime.RequiredError('designationID', 'Required parameter requestParameters.designationID was null or undefined when calling getDesignation.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/designations/{designationID}".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))).replace("{".concat("designationID", "}"), encodeURIComponent(String(requestParameters.designationID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DesignationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get designation
     * Get designation
     */
    RiskServiceApi.prototype.getDesignation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDesignationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get designations
     * Get designations
     */
    RiskServiceApi.prototype.getDesignationsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling getDesignations.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/designations".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.DesignationFromJSON); })];
                }
            });
        });
    };
    /**
     * Get designations
     * Get designations
     */
    RiskServiceApi.prototype.getDesignations = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDesignationsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get health check
     * Get health check
     */
    RiskServiceApi.prototype.getHealthCheckRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.verbose !== undefined) {
                            queryParameters['verbose'] = requestParameters.verbose;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/healthcheck",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.HealthCheckFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get health check
     * Get health check
     */
    RiskServiceApi.prototype.getHealthCheck = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHealthCheckRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all organizations
     * Get organizations
     */
    RiskServiceApi.prototype.getOrganizationsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.disabled !== undefined) {
                            queryParameters['disabled'] = requestParameters.disabled;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.OrganizationFromJSON); })];
                }
            });
        });
    };
    /**
     * Get all organizations
     * Get organizations
     */
    RiskServiceApi.prototype.getOrganizations = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getOrganizationsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get plan
     * Get plan
     */
    RiskServiceApi.prototype.getPlanRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling getPlan.');
                        }
                        if (requestParameters.planID === null || requestParameters.planID === undefined) {
                            throw new runtime.RequiredError('planID', 'Required parameter requestParameters.planID was null or undefined when calling getPlan.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/plans/{planID}".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))).replace("{".concat("planID", "}"), encodeURIComponent(String(requestParameters.planID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PlanFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get plan
     * Get plan
     */
    RiskServiceApi.prototype.getPlan = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPlanRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all plans
     * Get plans
     */
    RiskServiceApi.prototype.getPlansRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling getPlans.');
                        }
                        queryParameters = {};
                        if (requestParameters.assignee) {
                            queryParameters['assignee'] = requestParameters.assignee;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/plans".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.PlanFromJSON); })];
                }
            });
        });
    };
    /**
     * Get all plans
     * Get plans
     */
    RiskServiceApi.prototype.getPlans = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPlansRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get a specific risk
     * Get risk
     */
    RiskServiceApi.prototype.getRiskRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling getRisk.');
                        }
                        if (requestParameters.riskID === null || requestParameters.riskID === undefined) {
                            throw new runtime.RequiredError('riskID', 'Required parameter requestParameters.riskID was null or undefined when calling getRisk.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/risks/{riskID}".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))).replace("{".concat("riskID", "}"), encodeURIComponent(String(requestParameters.riskID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RiskFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get a specific risk
     * Get risk
     */
    RiskServiceApi.prototype.getRisk = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRiskRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get all risks
     * Get risks
     */
    RiskServiceApi.prototype.getRisksRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling getRisks.');
                        }
                        queryParameters = {};
                        if (requestParameters.state) {
                            queryParameters['state'] = requestParameters.state;
                        }
                        if (requestParameters.status !== undefined) {
                            queryParameters['status'] = requestParameters.status;
                        }
                        if (requestParameters.assignee) {
                            queryParameters['assignee'] = requestParameters.assignee;
                        }
                        if (requestParameters.assetID) {
                            queryParameters['assetID'] = requestParameters.assetID;
                        }
                        if (requestParameters.assetType !== undefined) {
                            queryParameters['assetType'] = requestParameters.assetType;
                        }
                        if (requestParameters.issueID) {
                            queryParameters['issueID'] = requestParameters.issueID;
                        }
                        if (requestParameters.source) {
                            queryParameters['source'] = requestParameters.source;
                        }
                        if (requestParameters.planID) {
                            queryParameters['planID'] = requestParameters.planID;
                        }
                        if (requestParameters.severity) {
                            queryParameters['severity'] = requestParameters.severity;
                        }
                        if (requestParameters.fromScore !== undefined) {
                            queryParameters['fromScore'] = requestParameters.fromScore;
                        }
                        if (requestParameters.toScore !== undefined) {
                            queryParameters['toScore'] = requestParameters.toScore;
                        }
                        if (requestParameters.fromCvssV3Score !== undefined) {
                            queryParameters['fromCvssV3Score'] = requestParameters.fromCvssV3Score;
                        }
                        if (requestParameters.toCvssV3Score !== undefined) {
                            queryParameters['toCvssV3Score'] = requestParameters.toCvssV3Score;
                        }
                        if (requestParameters.fromFirstDetectedTime !== undefined) {
                            queryParameters['fromFirstDetectedTime'] = requestParameters.fromFirstDetectedTime;
                        }
                        if (requestParameters.toFirstDetectedTime !== undefined) {
                            queryParameters['toFirstDetectedTime'] = requestParameters.toFirstDetectedTime;
                        }
                        if (requestParameters.fromLastDetectedTime !== undefined) {
                            queryParameters['fromLastDetectedTime'] = requestParameters.fromLastDetectedTime;
                        }
                        if (requestParameters.toLastDetectedTime !== undefined) {
                            queryParameters['toLastDetectedTime'] = requestParameters.toLastDetectedTime;
                        }
                        if (requestParameters.fromResolutionTime !== undefined) {
                            queryParameters['fromResolutionTime'] = requestParameters.fromResolutionTime;
                        }
                        if (requestParameters.toResolutionTime !== undefined) {
                            queryParameters['toResolutionTime'] = requestParameters.toResolutionTime;
                        }
                        if (requestParameters.fromDeadline !== undefined) {
                            queryParameters['fromDeadline'] = requestParameters.fromDeadline;
                        }
                        if (requestParameters.toDeadline !== undefined) {
                            queryParameters['toDeadline'] = requestParameters.toDeadline;
                        }
                        if (requestParameters.resolutionType) {
                            queryParameters['resolutionType'] = requestParameters.resolutionType;
                        }
                        if (requestParameters.assetImportance) {
                            queryParameters['assetImportance'] = requestParameters.assetImportance;
                        }
                        if (requestParameters.deviceCategory) {
                            queryParameters['deviceCategory'] = requestParameters.deviceCategory;
                        }
                        if (requestParameters.deviceOSFamily) {
                            queryParameters['deviceOSFamily'] = requestParameters.deviceOSFamily;
                        }
                        if (requestParameters.cveIdentifiers) {
                            queryParameters['cveIdentifiers'] = requestParameters.cveIdentifiers;
                        }
                        if (requestParameters.cisaKnownExploit !== undefined) {
                            queryParameters['cisaKnownExploit'] = requestParameters.cisaKnownExploit;
                        }
                        if (requestParameters.search !== undefined) {
                            queryParameters['search'] = requestParameters.search;
                        }
                        if (requestParameters.sort) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.cursor !== undefined) {
                            queryParameters['cursor'] = requestParameters.cursor;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/risks".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.RiskFromJSON); })];
                }
            });
        });
    };
    /**
     * Get all risks
     * Get risks
     */
    RiskServiceApi.prototype.getRisks = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRisksRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get the supporting data (i.e. risk evidence) for a risk
     * Get supporting
     */
    RiskServiceApi.prototype.getSupportingRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling getSupporting.');
                        }
                        if (requestParameters.riskID === null || requestParameters.riskID === undefined) {
                            throw new runtime.RequiredError('riskID', 'Required parameter requestParameters.riskID was null or undefined when calling getSupporting.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (requestParameters.acceptEncoding !== undefined && requestParameters.acceptEncoding !== null) {
                            headerParameters['Accept-Encoding'] = String(requestParameters.acceptEncoding);
                        }
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/risks/{riskID}/supporting".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))).replace("{".concat("riskID", "}"), encodeURIComponent(String(requestParameters.riskID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.SupportingFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get the supporting data (i.e. risk evidence) for a risk
     * Get supporting
     */
    RiskServiceApi.prototype.getSupporting = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSupportingRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get vulnerabilities
     * Get vulnerabilities
     */
    RiskServiceApi.prototype.getVulnerabilitiesRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling getVulnerabilities.');
                        }
                        queryParameters = {};
                        if (requestParameters.issueID) {
                            queryParameters['issueID'] = requestParameters.issueID;
                        }
                        if (requestParameters.severity) {
                            queryParameters['severity'] = requestParameters.severity;
                        }
                        if (requestParameters.source) {
                            queryParameters['source'] = requestParameters.source;
                        }
                        if (requestParameters.fromScore !== undefined) {
                            queryParameters['fromScore'] = requestParameters.fromScore;
                        }
                        if (requestParameters.toScore !== undefined) {
                            queryParameters['toScore'] = requestParameters.toScore;
                        }
                        if (requestParameters.fromCvssV3Score !== undefined) {
                            queryParameters['fromCvssV3Score'] = requestParameters.fromCvssV3Score;
                        }
                        if (requestParameters.toCvssV3Score !== undefined) {
                            queryParameters['toCvssV3Score'] = requestParameters.toCvssV3Score;
                        }
                        if (requestParameters.fromFirstDetectedTime !== undefined) {
                            queryParameters['fromFirstDetectedTime'] = requestParameters.fromFirstDetectedTime;
                        }
                        if (requestParameters.toFirstDetectedTime !== undefined) {
                            queryParameters['toFirstDetectedTime'] = requestParameters.toFirstDetectedTime;
                        }
                        if (requestParameters.fromLastDetectedTime !== undefined) {
                            queryParameters['fromLastDetectedTime'] = requestParameters.fromLastDetectedTime;
                        }
                        if (requestParameters.toLastDetectedTime !== undefined) {
                            queryParameters['toLastDetectedTime'] = requestParameters.toLastDetectedTime;
                        }
                        if (requestParameters.fromIssuePublishTime !== undefined) {
                            queryParameters['fromIssuePublishTime'] = requestParameters.fromIssuePublishTime;
                        }
                        if (requestParameters.toIssuePublishTime !== undefined) {
                            queryParameters['toIssuePublishTime'] = requestParameters.toIssuePublishTime;
                        }
                        if (requestParameters.fromIssueUpdateTime !== undefined) {
                            queryParameters['fromIssueUpdateTime'] = requestParameters.fromIssueUpdateTime;
                        }
                        if (requestParameters.toIssueUpdateTime !== undefined) {
                            queryParameters['toIssueUpdateTime'] = requestParameters.toIssueUpdateTime;
                        }
                        if (requestParameters.cisaKnownExploit !== undefined) {
                            queryParameters['cisaKnownExploit'] = requestParameters.cisaKnownExploit;
                        }
                        if (requestParameters.search !== undefined) {
                            queryParameters['search'] = requestParameters.search;
                        }
                        if (requestParameters.sort) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.offset !== undefined) {
                            queryParameters['offset'] = requestParameters.offset;
                        }
                        if (requestParameters.cursor !== undefined) {
                            queryParameters['cursor'] = requestParameters.cursor;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/vulnerabilities".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.VulnerabilityFromJSON); })];
                }
            });
        });
    };
    /**
     * Get vulnerabilities
     * Get vulnerabilities
     */
    RiskServiceApi.prototype.getVulnerabilities = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVulnerabilitiesRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Overview
     * Overview
     */
    RiskServiceApi.prototype.overviewRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling overview.');
                        }
                        if (requestParameters.graphQLRequest === null || requestParameters.graphQLRequest === undefined) {
                            throw new runtime.RequiredError('graphQLRequest', 'Required parameter requestParameters.graphQLRequest was null or undefined when calling overview.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/overview".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.GraphQLRequestToJSON)(requestParameters.graphQLRequest),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OverviewResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Overview
     * Overview
     */
    RiskServiceApi.prototype.overview = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.overviewRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update designation
     * Update designation
     */
    RiskServiceApi.prototype.updateDesignationRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling updateDesignation.');
                        }
                        if (requestParameters.designationID === null || requestParameters.designationID === undefined) {
                            throw new runtime.RequiredError('designationID', 'Required parameter requestParameters.designationID was null or undefined when calling updateDesignation.');
                        }
                        if (requestParameters.designationUpdate === null || requestParameters.designationUpdate === undefined) {
                            throw new runtime.RequiredError('designationUpdate', 'Required parameter requestParameters.designationUpdate was null or undefined when calling updateDesignation.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/designations/{designationID}".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))).replace("{".concat("designationID", "}"), encodeURIComponent(String(requestParameters.designationID))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.DesignationUpdateToJSON)(requestParameters.designationUpdate),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DesignationFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update designation
     * Update designation
     */
    RiskServiceApi.prototype.updateDesignation = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateDesignationRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update plan
     * Update plan
     */
    RiskServiceApi.prototype.updatePlanRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling updatePlan.');
                        }
                        if (requestParameters.planID === null || requestParameters.planID === undefined) {
                            throw new runtime.RequiredError('planID', 'Required parameter requestParameters.planID was null or undefined when calling updatePlan.');
                        }
                        if (requestParameters.planUpdate === null || requestParameters.planUpdate === undefined) {
                            throw new runtime.RequiredError('planUpdate', 'Required parameter requestParameters.planUpdate was null or undefined when calling updatePlan.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/plans/{planID}".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))).replace("{".concat("planID", "}"), encodeURIComponent(String(requestParameters.planID))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.PlanUpdateToJSON)(requestParameters.planUpdate),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.PlanFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update plan
     * Update plan
     */
    RiskServiceApi.prototype.updatePlan = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePlanRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update risks
     * Update risks
     */
    RiskServiceApi.prototype.updateRisksRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.orgUUID === null || requestParameters.orgUUID === undefined) {
                            throw new runtime.RequiredError('orgUUID', 'Required parameter requestParameters.orgUUID was null or undefined when calling updateRisks.');
                        }
                        if (requestParameters.body === null || requestParameters.body === undefined) {
                            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateRisks.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/v1/organizations/{orgUUID}/risks".replace("{".concat("orgUUID", "}"), encodeURIComponent(String(requestParameters.orgUUID))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: requestParameters.body,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RiskUpdateResultFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update risks
     * Update risks
     */
    RiskServiceApi.prototype.updateRisks = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateRisksRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return RiskServiceApi;
}(runtime.BaseAPI));
exports.RiskServiceApi = RiskServiceApi;
/**
 * @export
 */
exports.GetSupportingAcceptEncodingEnum = {
    Gzip: 'gzip'
};
